import React from 'react';
/**
 * Shop All Products page H1 heading.
 */
export function Heading() {
  return <h1 className="text-4xl sm:text-5xl font-black text-gray-900 uppercase tracking-tight mb-6" data-id="element-799">
      Shop All Products
    </h1>;
}